import { SET_DOCUMENTS } from "../actions/types";

const initialState = {
  documents: []
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DOCUMENTS: {
      return { ...state, documents: payload };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/documentsReducer.js